// extracted by mini-css-extract-plugin
module.exports = {"LoadingScreen":"FullscreenLoader_LoadingScreen__3If8h"};